import { runDemo } from "../shared/demoRunner";
import { createPostProcessBloomScene } from "./scene";

runDemo({ createScene: createPostProcessBloomScene });
